define(function (require) {

    //==================================================================================
    //=======================================[ Imports ]================================
    //==================================================================================

    var $ = require("jquery");
    var _ = require("lodash");
    var Promise = require("bluebird");
    var i18n = require("i18n");
    require("bootstrap");
    //gestion des dates
    var moment = require("moment");
    require("moment.fr");
    //Plugin pour la table
    var DataTable = require("datatables.net");
    require("datatables.bootstrap");
    var renders = require("datatables.render.methods");
    //Utilitaire charts
    var amchartsHelpers = require("amcharts.shared");
    //utilitaire couleurs
    var ColorManager = require("color-manager");
    //Sélection d'une période (date début + date fin)
    var FinancialItem = require("FinancialItem");
    //calls ajax
    var ajax = require("ajax-promise");
    var errorHandler = require("error-handler");
    //loader animation
    require("loadingoverlay");
    //charts
    require("amcharts.serial");
    require("amcharts.xy");
    require("amcharts.fr");


    //=================================================================================
    //=======================================[ Global ]================================
    //=================================================================================

    var api = {};

    // Pour que DataTables.net throw les erreurs dans la console au lieu d'un alert()
    $.fn.dataTable.ext.errMode = 'throw';

    Promise.config({
        warnings: false
    });

    var orderBy = {
        YTD: 0,
        M1: 1,
        M3: 2,
        M6: 3,
        Y1: 4,
        Y3: 5,
        Y5: 6,
        Y8: 7,
        Y10: 8
    };

    var typeInit = {
        localAjax: 0,
        serverAjax: 1
    };

    var TypeRequest = {
        CATEGORIE_ACTION: 0,
        obligCat: 1,
        flexiblesCat: 2,
        ConsultationTop10Cat: 3,
        fondsFlexible: 4,
        fondsMeilleursPerf: 5,
        fondsConsultationTop10: 6,
        ConsultationTop10SocieteGestion: 7,
        fondsTop10: 8,
        fondsFlop10: 9,
        CATEGORIE_OBLIGATION: 10,
        CATEGORIE_FLEXIBLE: 11
    };

    function ItemCourbe(id, name, type, color, financialItem) {
        this.ID = id;
        this.Nom = name;
        this.Type = type;
        this.Color = color;
        this.FinancialItem = financialItem;
    }

    var defaultCat = [];//[106, 98, 31, 126, 9, 116];
    if ($("#benchmark-list-default").val()) {
        defaultCat = $("#benchmark-list-default").val().split(",");
    }

    var colorManager = new ColorManager();

    var hexDigits = new Array
        ("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");


    //====================================================================================
    //=======================================[ Initialize ]===============================
    //====================================================================================

    $(function () {

        api = {
            columnDefs: {
                actionCat: [{ width: "65%", targets: 3 }, { width: "35%", targets: 4 }],//{ width: "35%", targets: 4 }
                obligCat: [{ width: "65%", targets: 3 }, { width: "35%", targets: 4 }],
                flexiblesCat: [{ width: "65%", targets: 3 }, { width: "35%", targets: 4 }]
            },
            columns: {
                actionCat: [
                    { name: "sUrl", visible: false },
                    { name: "ID_Cat", visible: false },
                    { name: "chbx", className: "text-center chbx", title: "", render: checkbox },
                    { name: "sNom", title: i18n.actions, render: renderNom },
                    { name: "nRet", className: "variable-action-text text-center", title: i18n.perfcum, render: renderAmount }//i18n.perfcumulee
                ],
                obligCat: [
                    { name: "sUrl", visible: false },
                    { name: "ID_Cat", visible: false },
                    { name: "chbx", className: "text-center chbx", title: "", render: checkbox },
                    { name: "sNom", title: i18n.obligations, render: renderNom },
                    { name: "nRet", className: "variable-oblig-text text-center", title: i18n.perfcum, render: renderAmount }
                ],
                flexiblesCat: [
                    { name: "sUrl", visible: false },
                    { name: "ID_Cat", visible: false },
                    { name: "chbx", className: "text-center chbx", title: "", render: checkbox },
                    { name: "sNom", title: i18n.flexibles, render: renderNom },
                    { name: "nRet", className: "variable-flexible-text text-center", title: i18n.perfcum, render: renderAmount }
                ]
            },
            searchUrl: "/Home/performance",
            urlLangage: "/Areas/Shared/Static/localization/datatables_french.json",
            defaultDisplayCount: {
                actionCat: 6,
                obligCat: 3,
                flexiblesCat: 3
            },
            backColor: {
                actionCat: [],
                obligCat: ["#009688", "#009688", "#4DB6AC", "#827717"],
                flexiblesCat: ["#B71C1C", "#B71C1C", "#D32F2F", "#E57373"]
            },
            $tableResult: {
                actionCat: $("#benchmark-cat"),
                obligCat: $("#benchmark-action-cat"),
                flexiblesCat: $("#benchmark-oblig-cat")
            },
            $blockContainer: {
                benchmark: $(".benchmark-block")
            },
            ajaxCalls: [],
            ajaxSource: {
                perfTab: ".load-",
                courbeData: "#benchmark-courbe-data",
                chartHisto: "#benchmark-chart-histo"
            },
            selectedProduits: [],
            liste_courbes: [],
            graphs: [{ id: "divChart-benchmark", graph: {} }],
            dtStart: moment(new Date),
            sDtEnd: moment(new Date),
            orderBy: orderBy.Y1,
            $tabContainer: $(".benchmark-container"),
            colorRecovery: []
        };

        // Pour chaque colonne on ajoute une property "data" égale au nom (correspond au field de la datasource)
        for (var i = 0; i < api.columns.actionCat.length; i++) {
            api.columns.actionCat[i].data = api.columns.actionCat[i].name;
        }

        for (i = 0; i < api.columns.obligCat.length; i++) {
            api.columns.obligCat[i].data = api.columns.obligCat[i].name;
        }

        for (i = 0; i < api.columns.flexiblesCat.length; i++) {
            api.columns.flexiblesCat[i].data = api.columns.flexiblesCat[i].name;
        }

        // color to exclude
        colorManager.excludeforProduits = $.merge(api.backColor.obligCat, api.backColor.flexiblesCat);

        // get the default period
        var $aLink = $(".tabs li.active a", api.$blockContainer.benchmark);
        setPeriodFromKey($aLink.data("period"));

        initDataTable(typeInit.localAjax);
    });

    //====================================================================================
    //=========================================[ Events ]=================================
    //====================================================================================

    $(function () {

        $('.table').on("click", '.chbx input[type="checkbox"]', function () {
            var id = $(this).data("cat");
            var indx = $.inArray(id, api.selectedProduits);
            if (indx === -1) {
                api.selectedProduits.push($(this).data("cat"));
            }
            else {
                api.liste_courbes = CleanupListCourbes([api.selectedProduits[indx]]);
                api.selectedProduits.splice(indx, 1);

                //Free color for next curve
                var ids = _.map(api.colorRecovery, function (elt, index) { return elt.ID; });

                indx = $.inArray(id, ids);
                if (indx !== -1) {
                    var indx2 = $.inArray(api.colorRecovery[indx].Color, colorManager.excludeforProduits);
                    if (indx2 !== -1)
                        colorManager.excludeforProduits.splice(indx2, 1);

                    api.colorRecovery.splice(indx, 1);
                }

                // remove checkbox background color
                $("input[data-cat='" + $(this).data("cat") + "']", api.$tableResult.actionCat).parents("td.chbx").removeAttr("style");
                $("input[data-cat='" + $(this).data("cat") + "']", api.$tableResult.obligCat).parents("td.chbx").removeAttr("style");
                $("input[data-cat='" + $(this).data("cat") + "']", api.$tableResult.flexiblesCat).parents("td.chbx").removeAttr("style");
            }

            //delete onload data
            $(api.ajaxSource.courbeData).val("");
            $(api.ajaxSource.chartHisto).val("");

            AddElementsToChart();
        });

        reloadData();

        api.$blockContainer.benchmark.find(".tabs").find("a").on("click", function (e) {
            setPeriodFromKey($(this).data("period"));
            api.$blockContainer.benchmark.find(".tabs").find("li").removeClass("active");
            $(this).parents("li").addClass("active");

            //delete onload data
            $(api.ajaxSource.courbeData).val("");
            $(api.ajaxSource.chartHisto).val("");
            $("[class^='load-']").val("");

            //abort current ajax requests (unresolved)
            cancelAjax();

            // update tables
            initDataTable(typeInit.serverAjax);
        });

    });

    //====================================================================================
    //=======================================[ Functions ]================================
    //====================================================================================

    function initDataTable(cTypeInit) {

        // Actions catégories
        initactionCatTable(cTypeInit);

        // Oblig. catégorie
        initobligCatTable(cTypeInit);

        // Flexibles catégories
        initflexiblesCatTable(cTypeInit);
    }

    function initactionCatTable(cTypeInit) {
        api.catOptions = {
            $table: api.$tableResult.actionCat,
            destroy: true,
            columnDefs: api.columnDefs.actionCat,
            url: api.searchUrl,
            columns: api.columns.actionCat,
            orderbyColumnNum: [3, 'asc'], //-- order by sNom
            defaultDisplayCount: api.defaultDisplayCount.actionCat,
            params: { nOrderBy: api.orderBy, defaultCat: defaultCat, typeRequest: TypeRequest.CATEGORIE_ACTION },
            colorArray: api.backColor.actionCat,
            evolutionIconUrl: "",
            cTypeInit: cTypeInit,
            bDefaultCheckable: true,
            initCompliteFunc: function () { api.catOptions.cTypeInit = typeInit.serverAjax; }
        };

        api.benchmarkactionCatDataTableApi = getTable(api.catOptions);
    }

    function initobligCatTable(cTypeInit) {
        api.catTableOptions = {
            $table: api.$tableResult.obligCat,
            destroy: true,
            columnDefs: api.columnDefs.obligCat,
            url: api.searchUrl,
            columns: api.columns.obligCat,
            orderbyColumnNum: [4, 'desc'], //-- order by nRet
            defaultDisplayCount: api.defaultDisplayCount.obligCat,
            params: { nOrderBy: api.orderBy, typeRequest: TypeRequest.CATEGORIE_OBLIGATION },
            colorArray: api.backColor.obligCat,
            cTypeInit: cTypeInit,
            bDefaultCheckable: false,
            //evolutionIconUrl: "/Areas/Shared/Static/img/fleche_up.png",
            initCompliteFunc: function () { api.catTableOptions.cTypeInit = typeInit.serverAjax; }
        };

        api.benchmarkobligCatDataTableApi = getTable(api.catTableOptions);
    }

    function initflexiblesCatTable(cTypeInit) {
        api.flexiblesCatOptions = {
            $table: api.$tableResult.flexiblesCat,
            destroy: true,
            columnDefs: api.columnDefs.flexiblesCat,
            url: api.searchUrl,
            columns: api.columns.flexiblesCat,
            orderbyColumnNum: [4, 'desc'], //-- order by nRet
            defaultDisplayCount: api.defaultDisplayCount.flexiblesCat,
            params: { nOrderBy: api.orderBy, typeRequest: TypeRequest.CATEGORIE_FLEXIBLE },
            colorArray: api.backColor.flexiblesCat,
            cTypeInit: cTypeInit,
            bDefaultCheckable: false,
            //evolutionIconUrl: "/Areas/Shared/Static/img/fleche_down.png",
            initCompliteFunc: function () { api.flexiblesCatOptions.cTypeInit = typeInit.serverAjax; }
        };

        api.benchmarkflexiblesCatDataTableApi = getTable(api.flexiblesCatOptions);
    }

    function getTable(option) {
        return option.$table.DataTable({
            destroy: option.destroy,
            columnDefs: option.columnDefs,
            autoWidth: false,
            lengthMenu: [5, 10, 25, 50, 100],
            pageLength: option.defaultDisplayCount, //Nombre de lignes affichées par défaut
            bLengthChange: false,
            searching: false,
            ordering: false,
            processing: false,
            serverSide: true,
            bInfo: false,
            order: option.orderbyColumnNum,
            pagingType: "numbers",
            dom: "<f><tr><'dataTableFooter'pil><'clearfix'>",
            columns: option.columns,
            language: {
            },
            ajax: function (data, callback, settings) {

                var params = $.extend(data, option.params);

                if ($(".load-" + option.params.typeRequest).val()) {
                    var dataLoad = $(".load-" + option.params.typeRequest).val();
                    var dataResult = JSON.parse(dataLoad);
                    callback(dataResult);
                }
                else {
                    var internalAjax = ajax.post(option.url, params);
                    api.ajaxCalls.push(internalAjax);

                    internalAjax.then(function (dataResult) {
                        $(".load-" + option.params.typeRequest).val(JSON.stringify(dataResult));
                        callback(dataResult);
                    }).catch(function (ex) {
                        if (ex.message !== "abort") {
                            errorHandler.displayError(ex);
                        }
                    }).then(function () {
                        _.remove(api.ajaxCalls, function (item) { return item === internalAjax; });
                    });
                }
            },
            preDrawCallback: function () {
                preDrawCallback(option);
            },
            drawCallback: function () {
                drawCallback(option);
            },
            initComplete: option.initCompliteFunc,
            fnRowCallback: function (nRow, aData, iDisplayIndex) {
                fnRowCallback(option, nRow, aData, iDisplayIndex);
            }
        });
    }


    // Add/Remove curves
    function AddElementsToChart() {

        var listIdCat = api.selectedProduits;

        if (listIdCat.length !== 0)
            GetNewCourbes(listIdCat);
    }

    // Fetch the new curves (color, id, type) based on their id
    function GetNewCourbes(listIdCat) {

        var listCatUsed = listIdCat ? listIdCat : Array();

        if ($(api.ajaxSource.courbeData).val()) {

            AddCourbe(JSON.parse($(api.ajaxSource.courbeData).val()));

            updateBackgroundColor();

            GetMainGraphs();
        }
        else {
            return ajax.post("/Home/GetCourbesData", {
                ID_Produit: 0,
                idListCat: JSON.stringify(listCatUsed),
                idListIndice: JSON.stringify([]),
                nbCourbes: listCatUsed.length
            })
                .then(function (data) {

                    $(api.ajaxSource.courbeData).val(data.Data);

                    AddCourbe(JSON.parse(data.Data));

                    updateBackgroundColor();

                    GetMainGraphs(); // We reload all the charts with the new curves
                });
        }

    }

    // Rebuilds all the dynamic graphs
    function GetMainGraphs() {

        if ($(api.ajaxSource.chartHisto).val()) {
            var amChartConfig = JSON.parse($(api.ajaxSource.chartHisto).val());
            api.graphs[0].graph = AmCharts.makeChart(api.graphs[0].id, amChartConfig);
        }
        else {
            DisplayLoader("graph");
            return ajax.post("/Home/GetChartHisto_Historique", {
                ID_Produit: 0,
                jsonListeCourbes: JSON.stringify(api.liste_courbes),
				sDtStart: moment(api.dtStart).format("DD-MM-YYYY")
            })
                .then(function (data) {

                    $(api.ajaxSource.chartHisto).val(data.Data);

                    // Histo graph
                    var amChartConfig = JSON.parse(data.graph);

                    api.graphs[0].graph = AmCharts.makeChart(api.graphs[0].id, amChartConfig);

                    DoneLoading("graph");
                });
        }

    }

    function reloadData() {
        slectedPeriode = $("li.acive", api.$blockContainer.benchmark.find(".tabs"));
        if (slectedPeriode.length > 0) {
            setPeriodFromKey($("a", slectedPeriode).data("period"));
        }
    }   


    //==================================================================================
    //=================================[ table actions ]================================
    //==================================================================================

    function preDrawCallback(option) {
        option.$table.hide();
        api.$tabContainer.LoadingOverlay("show");
        if (option.colorArray.length > 0) {
            option.$table.find('th').css({ backgroundColor: option.colorArray[0], borderColor: option.colorArray[0] });
        }

        $("th.to-dark", api.$blockContainer.benchmark).addClass("dark");
        $(".to-dark", api.$blockContainer.benchmark).removeClass("to-dark");
    }

    function drawCallback(option) {
        option.$table.show();
        api.$tabContainer.LoadingOverlay("hide", true);
        AddElementsToChart();
    }

    function fnRowCallback(option, nRow, aData, iDisplayIndex) {
        // save IDs for chart
        if (option.bDefaultCheckable) {
            var idx = $.inArray(parseInt(aData.ID_Cat), api.selectedProduits);
            if (idx === -1 && api.selectedProduits.length < 3) {
                api.selectedProduits.push(parseInt(aData.ID_Cat));
            }
        }

        resetChecks(aData.ID_Cat, nRow);

        updatetabYearHeader($("li.active a", api.$blockContainer.benchmark.find(".tabs")).data("period"));
    }

    //==================================================================================
    //=====================================[ Utilities ]================================
    //==================================================================================

    function cancelAjax() {

        for (var i = 0; i < api.ajaxCalls.length; i++) {
            api.ajaxCalls[i].abort();
        }
    }

    // Add a curve to the list of curves
    function AddCourbe(list_elt) {

        for (var i = 0; i < list_elt.length; i++) {

            var IDFound;
            var courbe;

            var idx = $.inArray(list_elt[i].ID, api.selectedProduits);
            if (idx !== -1)
                IDFound = api.selectedProduits[idx];

            idx = $.inArray(list_elt[i], api.liste_courbes);
            if (idx !== -1)
                courbe = api.liste_courbes[idx];

            if (IDFound && !courbe) {
                var financialItem = new FinancialItem(list_elt[i].ID, list_elt[i].Type, 0, null);
                var courbeNew = new ItemCourbe(list_elt[i].ID, list_elt[i].Nom, list_elt[i].Type, list_elt[i].Color, financialItem);

                var ids = _.map(api.colorRecovery, function (elt, index) { return elt.ID; });
                var clrs = _.map(api.colorRecovery, function (elt, index) { return elt.Color; });
                idx = $.inArray(list_elt[i].ID, ids);

                if (idx === -1) {
                    if ($.inArray(list_elt[i].Color, clrs) === -1)
                        api.colorRecovery.push(courbeNew);
                    else {
                        colorManager.excludeforProduits = $.merge(colorManager.excludeforProduits, clrs);
                        courbeNew.Color = colorManager.CheckColorAllowedForProduits(courbeNew.Color);
                        api.colorRecovery.push(courbeNew);
                    }
                }
                else {
                    courbeNew.Color = api.colorRecovery[idx].Color;
                }

                // We add all the curves to the list 
                api.liste_courbes.push(courbeNew);
            }
        }
    }

    function CleanupListCourbes(listCourbes) {

        // We remove elements that already are in api.liste_courbes
        _.remove(api.liste_courbes, function (elt) {
            return _.find(listCourbes, function (id) { return parseInt(id) === parseInt(elt.ID); }) !== null;
        });

        return _.uniq(api.liste_courbes); // We remove duplicates
    }

    function updateBackgroundColor() {

        // update cat back color
        $.each(api.liste_courbes, function (index, elt) {
            var $td = api.$tableResult.actionCat.find("input[data-cat=" + elt.ID + "]").parents("td.chbx");
            $td.css({ "background-color": elt.Color, "border-color": elt.Color });
        });

        // update top cat chart color
        $.each(api.liste_courbes, function (index, elt) {
            var $td = api.$tableResult.obligCat.find("input[data-cat=" + elt.ID + "]").parents("td.chbx");
            if ($td.length > 0) {
                var idx = $.inArray($td.parents("tr").get(0), api.$tableResult.obligCat.find("tr"));
                if (idx !== -1) {
                    $td.css({ backgroundColor: api.backColor.obligCat[idx] });
                    api.liste_courbes[index].Color = api.backColor.obligCat[idx];
                }
            }
        });

        // update flop cat chart color
        $.each(api.liste_courbes, function (index, elt) {
            var $td = api.$tableResult.flexiblesCat.find("input[data-cat=" + elt.ID + "]").parents("td.chbx");
            if ($td.length > 0) {
                var idx = $.inArray($td.parents("tr").get(0), api.$tableResult.flexiblesCat.find("tr"));
                if (idx !== -1) {
                    $td.css({ backgroundColor: api.backColor.flexiblesCat[idx] });
                    api.liste_courbes[index].Color = api.backColor.flexiblesCat[idx];
                }
            }
        });
    }

    //Function to convert rgb color to hex format
    function rgb2hex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }

    function hex(x) {
        return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }

    function DisplayLoader(type) {
        $('.qtjs-panel-reloaded-' + type).LoadingOverlay("show");
    }

    // This function is called when one main function has finished its task.
    function DoneLoading(type) {
        $('.qtjs-panel-reloaded-' + type).LoadingOverlay("hide");
    }

    function uncheckElts(eltArray) {
        $(eltArray).prop("checked", false);
    }

    function checkElts(eltArray) {
        $(eltArray).prop("checked", true);
    }

    function resetChecks(idCat, nRow) {
        var idx = $.inArray(parseInt(idCat), api.selectedProduits);
        if (idx !== -1) {
            $('.chbx input[type="checkbox"]', $(nRow)).attr("checked", true);//.prop("checked", true);
        }
        else {
            $('.chbx input[type="checkbox"]', $(nRow)).attr("checked", false);//.prop("checked", false);
        }
    }

    function setPeriodFromKey(key) {
        api.dtStart = moment(new Date());
        switch (key) {
            case "1m":
                api.dtStart.add(-1, 'months');
                api.orderBy = orderBy.M1;
                break;
            case "1a":
                api.dtStart.add(-1, 'years');
                api.orderBy = orderBy.Y1;
                break;
            case "3a":
                api.dtStart.add(-3, 'years');
                api.orderBy = orderBy.Y3;
                break;
            case "5a":
                api.dtStart.add(-5, 'years');
                api.orderBy = orderBy.Y5;
                break;
            case "8a":
                api.dtStart.add(-8, 'years');
                api.orderBy = orderBy.Y8;
                break;
            case "ytd":
                api.dtStart = moment("01/01/" + api.dtStart.format("Y"), "dd/MM/YYYY");
                api.orderBy = orderBy.YTD;
                break;
        }
    }

    function updatetabYearHeader(key) {
        switch (key) {
            case "1m":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorie1mois);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorie1mois);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorie1mois);
                break;
            case "1a":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorie1annnnnnn);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorie1annnnnnn);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorie1annnnnnn);
                break;
            case "3a":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorie3ans);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorie3ans);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorie3ans);
                break;
            case "5a":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorie5ans);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorie5ans);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorie5ans);
                break;
            case "8a":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorie8ans);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorie8ans);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorie8ans);
                break;
            case "ytd":
                $("th.variable-action-text", api.$tableResult.actionCat).html(i18n.categorieYTD);
                $("th.variable-oblig-text", api.$tableResult.obligCat).html(i18n.categorieYTD);
                $("th.variable-flexible-text", api.$tableResult.flexiblesCat).html(i18n.categorieYTD);
                break;
        }
    }

    //==================================================================================
    //=======================================[ Renders ]================================
    //==================================================================================

    function renderNom(data, type, row, meta) {

        if (!row.sNom) row.sNom = "";

        var result = row.sNom;

        if (row.sUrl !== null && row.sUrl !== "") {
            result = "<a href='" + row.sUrl + "'>" + row.sNom + "</a>";
        }
        return result;
    }

    function renderAmount(data, type, row, meta) {
        if (!data || isNaN(data) || parseFloat(data) === 0) return "-";

        if (parseFloat(data) > 0) {
            return "<span class='text-center label_positive'>" + data.toFixed(2) + " %" + "</span>";
        }
        else if (parseFloat(data) < 0) {
            return "<span class='text-center label_negative'>" + data.toFixed(2) + " %" + "</span>";
        }

        return data;
    }

    function renderAmountVolat(data, type, row, meta) {
        if (!data || isNaN(data) || parseFloat(data) === 0) return "-";

        return "<span class='text-center'>" + data.toFixed(2) + " %" + "</span>";
    }

    function checkbox(data, type, row, meta) {
        return '<label class="fancy-checkbox m-r-0"> <input type="checkbox" data-cat="' + row.ID_Cat + '"/> <span class="fancy-content"></span> </label>';
    }

});
